import {Injectable} from '@angular/core';

@Injectable()
export class TimeHelperProvider {
    public WEEKDAYS_IN_SWEDISH = ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör']; // js Date.getDay() has sun as 0.
    public MONTHS_IN_SWEDISH = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];

    constructor() {
    }

    // This script is released to the public domain and may be used, modified and
    // distributed without restrictions. Attribution not necessary but appreciated.
    // Source: https://weeknumber.net/how-to/javascript
    public getWeekNumberOfDate(date : Date) {
        date.setHours(0, 0, 0, 0);
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        // January 4 is always in week 1.
        var week1 = new Date(date.getFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                                - 3 + (week1.getDay() + 6) % 7) / 7);
    }

    public displayDate(year: boolean, month: boolean, day: boolean) {
        let actualDate: string = '';
        let ad = new Date();

        if (year) {
            actualDate += this.leadingZero(ad.getFullYear().toString());
            actualDate += "-";
        }

        if (month) {
            actualDate += this.leadingZero((ad.getMonth() + 1).toString());
            actualDate += "-";
        }

        if (day) {
            actualDate += this.leadingZero(ad.getDate().toString());
        }

        return actualDate;
    }

    public display(isYear: boolean, isMonth, isDay: boolean, isHour: boolean, isMinutes: boolean, isSecond: boolean) {

        let time: string = '';
        let d = new Date();

        if (isDay) {
            time += this.leadingZero(d.getDate().toString());
            time += " ";
        }

        if (isMonth) {
            time += this.MONTHS_IN_SWEDISH[d.getMonth()];
            time += " ";
        }

        if (isYear) {
            time += d.getFullYear().toString();
            time += " ";
        }

        if (isHour) {
            time += this.leadingZero(d.getHours().toString());
        }

        if (isMinutes) {
            time += ":";
            time += this.leadingZero(d.getMinutes().toString());
        }

        if (isSecond) {
            time += ":";
            time += this.leadingZero(d.getSeconds().toString());
        }

        return time;
    }

    private leadingZero(timePart: string) {
        if (timePart.length < 2) {
            timePart = '0' + timePart;
        }
        
        return timePart;
    }

}



// WEBPACK FOOTER //
// ./src/providers/time-helper/time-helper.ts